import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@newtontechnologies/applib-frontend';
const DurationMessage = ({ duration }) => {
    const { intl } = useI18n();
    if (duration === 'unknown') {
        return (_jsx("p", { className: "upload-form__unknown-duration", children: intl.formatMessage({ id: 'unknownDuration' }) }));
    }
    if (duration === 'none') {
        return null;
    }
    return (_jsxs("p", { className: "upload-form__duration", children: [_jsxs("span", { children: [intl.formatMessage({ id: 'recordingDuration' }), ' '] }), duration, ' ', intl.formatMessage({ id: 'minutes' })] }));
};
export default DurationMessage;
